/**
 * Lib.Common: Reactive Media Query
 */


const $mediaName = ['s','m','l','xl','xxl','xxxl'];
const $mediaBreak = [320, 568, 769, 992, 1200, 1600];


let $media = {};


let media = $mediaBreak.map(e => matchMedia('screen and (min-width:' + e + 'px)'));
$mediaName.forEach((e,i) => {
    const fn = () => {
        $media[e] = media[i].matches;
    };
    fn();
    media[i].addListener(fn);
});


export default $media;
